let GRAPH_URL
let ENV
const APP_ID = "595b29c56bce953ca7b20909"

const url = window.location.host.split(":")[0]
if (url === "survey-sat.acehardware.ph") {
     GRAPH_URL = "https://g-sat.smomni.com/graphql"
    //SAVE_CONTACT_URL = "https://g-sat.smomni.com/pub/saveBranchCard?branchId="
    ENV = "sat"
} else if (url === "survey.acehardware.ph") {
     GRAPH_URL = "https://g.smomni.com/graphql"
    //SAVE_CONTACT_URL = "https://g.smomni.com/pub/saveBranchCard?branchId="
    ENV = "production"
} else {
     GRAPH_URL = "http://localhost:4200/graphql"
    //SAVE_CONTACT_URL = "http://localhost:4200/pub/saveBranchCard?branchId="
    ENV = "development"
}

export  {
     GRAPH_URL, ENV, APP_ID
 }